import { Form, Formik, FormikHelpers } from "formik";
import { SpeckleImportModel } from "./types/SpeckleImportModel";
import { speckleImportSteps } from "./steps/steps";
import { speckleImport } from "../lib/actions/speckleImport";
import { popToastError } from "lib/actions/toast";
import { useCurrentProjectId } from "lib/hooks/useProject";
import { useWizard } from "components/elements/Wizard/useWizard";
import { useUploadDialog } from "../UploadDialogProvider";
import Wizard from "components/elements/Wizard/Wizard";

export default function SpeckleWizard() {
  return (
    <Wizard>
      <SpeckleImportForm />
    </Wizard>
  );
}

function SpeckleImportForm() {
  const projectId = useCurrentProjectId();
  const { step: iStep, stepForward } = useWizard();
  const { close } = useUploadDialog();

  const step = speckleImportSteps[iStep],
    validation = step?.validation,
    StepComponent = step?.component ?? (() => null),
    isLastStep = iStep === speckleImportSteps.length - 1;

  const initialFormValues: SpeckleImportModel = {
    connectedAccountId: null,
    workspaceId: null,
    workspaceName: null,
    projectId: null,
    projectName: null,
    modelId: null,
    modelName: null,
    versionId: null,
  };

  function onSubmit(
    values: SpeckleImportModel,
    form: FormikHelpers<SpeckleImportModel>,
  ) {
    if (!isLastStep) {
      form.setSubmitting(false);
      stepForward();
    } else {
      speckleImport(projectId, values)
        .then(() => {
          close();
        })
        .catch((error) => {
          popToastError("Import failed.");
          console.error(error);
        })
        .finally(() => {
          form.setSubmitting(false);
        });
    }
  }

  return (
    <Formik
      initialValues={initialFormValues}
      onSubmit={onSubmit}
      validationSchema={validation}
      validateOnChange
      validateOnBlur
    >
      <Form className="pl-11 pr-5 pt-11">
        <div className="relative h-[45rem]">
          <StepComponent />
        </div>
      </Form>
    </Formik>
  );
}
